export default __webpack_public_path__ + "static/media/multi-factor-card-banner.961698bc.png";